import FreeEmailModal from './FreeEmailModal';

export default FreeEmailModal;
